export const initMetaPixel = (pixelId: string = '20690000673664574') => {
  if (typeof window === 'undefined') return;
  const f: any = window;
  if (f.fbq) return;
  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  if (!f._fbq) f._fbq = n;
  n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
  const t = document.createElement('script');
  t.async = !0; t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const target = document.head || document.body || document.documentElement;
  target.appendChild(t);
  n('init', pixelId);
  n('track', 'PageView');
};

export const trackAddToCart = () => {
  if (typeof (window as any).fbq === 'function') {
    (window as any).fbq('track', 'AddToCart', {
      value: 6.39,
      currency: 'USD'
    });
  }
};
